// Основная конфигурация приложения
export const CONFIG = {
  currentUrl: 'https://my-horoscope.ru/app',
  
  api: {
    baseUrl: 'https://v2.my-horoscope.ru/api/',
    timeout: 10000,
  },
  
  // Внешние ссылки
  links: {
    telegramAstrolog: 'https://t.me/tatyana_astrolog_omsk',
    telegramDeveloper: 'https://t.me/mir_zwezd',
    subscriptionOffer: 'https://bytepace.ru/world-of-stars/offer',
    supportEmail: 'mir_zvezd@bk.ru',
  },
  
  // Таймауты
  timeouts: {
    permission: 5000,
    notificationCheck: 100,
  },
  
  // Кеш
  cache: {
    updateInterval: 24 * 60 * 60 * 1000, // 1 день
  },
  
  // Настройки совместимости
  compatibility: {
    minIOSVersion: 15,
    enableServiceWorkerForLegacyIOS: false,
  },
} as const; 